
const stage = [
    {
        "key": "stage.subheadline",
        "string": "Mělká geotermální energie ve střední Evropě"
    }
]

export default stage



// WEBPACK FOOTER //
// ./src/i18n/cs/landingpage/stage.js